module.exports = __webpack_public_path__ + "static/img/04.78eb19a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/04.jpg
// module id = 419
// module chunks = 1